import React from "react";

const OperatorButton = ({ onclick, icon }) => {
  return (
    <li className="list-inline-item  d-none d-sm-inline-block showbtn">
      <div className="btn nav-btn nav-btn-light-sec" onClick={onclick}>
        <i className={icon}></i>
      </div>
    </li>
  );
};
export default OperatorButton;
